import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import { Mutation } from "vuex-class";

import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import LoginController from '@/assets/ts/controller/LoginController';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import TkField from '@/../bower_components/teknisavuecomponents/components/fields/TkField.vue';
import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import PopupController from '@/assets/ts/controller/PopupController';
import Messages from '@/assets/ts/utils/Messages';

@Component({
  name: 'ChangePassword',
  components: {
    TkField,
    TkForm,
  },
})
export default class ChangePassword extends Vue {
  // [ PROPS ]
  @Prop({ default: null})
  private name: string;

  @Prop({ default: (): any => null})
  private closeAction: () => void;

  @Prop({ default: () => {}})
  private defaultRow: any;

  @Prop({ default: null })
  private mode: string;

  @Prop({ default: false })
  private isVisible: boolean;
  // [ PROPS ]

  // [ DATA ]
  private tkForm: any = {
    row: {},
    loading: false,
  };

  private screen = {
    title: 'Alterar Senha',
  };

  private actions = {
    close: this.close,
    save: this.savePassword,
    saveDisabled: false,
  }

  private defaultFields: Field[] = [
    {
      name: 'ACTUAL_PASSWORD',
      label: 'Senha Atual',
      size: 12,
      type: 'password',
      readonly: false,
      required: true,
    },
    {
      name: 'NEW_PASSWORD',
      label: 'Nova Senha',
      size: 6,
      type: 'password',
      readonly: false,
      required: true,
    },
    {
      name: 'CONFIRM_NEW_PASSWORD',
      label: 'Confirmar Nova Senha',
      size: 6,
      type: 'password',
      readonly: false,
      required: true,
    },
  ];

  private confirmationFields: Field[] = [
    {
      name: 'EMAIL',
      label: 'Usuário',
      size: 12,
      type: 'text',
      readonly: false,
      required: true,
    },
    {
      name: 'DTNASCIMENTO',
      label: 'Nascimento',
      size: 6,
      type: 'date',
      readonly: false,
      required: true,
    },
    {
      name: 'DTADMISSAO',
      label: 'Admissão',
      size: 6,
      type: 'date',
      readonly: false,
      required: true,
    },
    {
      name: 'CPF',
      label: 'CPF',
      size: 12,
      type: 'text',
      mask: '###.###.###-##',
      readonly: false,
      required: true,
    },
    {
      name: 'NEW_PASSWORD',
      label: 'Nova Senha',
      size: 6,
      type: 'password',
      readonly: false,
      required: true,
    },
    {
      name: 'CONFIRM_NEW_PASSWORD',
      label: 'Confirmar Nova Senha',
      size: 6,
      type: 'password',
      readonly: false,
      required: true,
    },
  ];

  private modes = { ...PopupController.CP_POPUP_MODES };
  // [ DATA ]

  // [ STORE ]
  @Mutation('controlPopUp')
  private controlPopUp: (popUp: {[key: string]: any, popUp: string}) => void;
  // [ STORE ]

  // [ COMPUTED ]
  private get modesData(): any {
    return {
      afterResetPassword: {
        description: 'Definições de campos/informações que deverão estar disponíveis após o reset da senha, para que uma nova seja cadastrada',
        fields: this.defaultFields,
      },
      normal: {
        description: 'Definições de campos/informações que deverão estar disponíveis ao selecionar a opção "Alterar Senha"',
        fields: this.defaultFields,
      },
      confirmationReset: {
        description: '',
        fields: this.confirmationFields,
        save: LoginController.confirmationChangePassword
      }
    }
  }

  private get currentMode() {
    return this.modesData[this.mode] ? this.modesData[this.mode] : {};
  }
  private get fields() {
    return this.currentMode.fields;
  }

  private get isAfterResetPasswordMode() {
    return this.mode === this.modes.afterResetPassword;
  }

  private get isConfirmationResetMode() {
    return this.mode === this.modes.confirmationReset;
  }
  // [ COMPUTED ]

  // [ EMIT ]
  @Emit('close-popup')
  private close() {
    this.tkForm.row = {};
  }
  // [ EMIT ]

  // [ METHODS ]
  @Watch('isVisible', { immediate: true, deep: true })
  private isVisibleOnChange(newValue: boolean) {
    if (newValue) {
      this.tkForm.row = { ...this.tkForm.row, ...this.defaultRow };
    }
  }
  
  private async savePassword() {
    if (!this.tkForm.row.validate()) {
      SnackbarUtils.showMessage(Messages.REQUIRED_FIELDS_NOT_FILLED, SnackbarUtils.TYPE_ALERT);
      return;
    }

    const beforeRequestIsValid = await this.beforeRequest();
    if (!beforeRequestIsValid) {
      return;
    }

    let response = null;

    try {
      if (this.currentMode.save) {
        response = await this.currentMode.save(this.tkForm.row);
      } else {
        response = await LoginController.updatePassword(
          this.tkForm.row.ACTUAL_PASSWORD,
          this.tkForm.row.NEW_PASSWORD,
          this.tkForm.row.CONFIRM_NEW_PASSWORD,
          this.tkForm.row.EMAIL // Passado como defaultRow
        );
      }
    } catch (err) {
      const errAny: any = err;

      const message = errAny.response && errAny.response.data ? errAny.response.data.error : 'Não foi possível concluir a alteração da senha. Tente novamente mais tarde';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
    }

    this.afterRequest();

    if (!response.success) {
      SnackbarUtils.showMessage(response.message, SnackbarUtils.TYPE_ERROR);
      return;
    }

    SnackbarUtils.showMessage(Messages.PASSWORD_UPDATED_SUCESS, SnackbarUtils.TYPE_SUCCESS);
    
    // Realiza novamente o login, caso o popUp esteja em modo 'afterResetPassword'
    if (this.isAfterResetPasswordMode || this.isConfirmationResetMode) {
      LoginController.login(this.tkForm.row.EMAIL, this.tkForm.row.NEW_PASSWORD);
    }

    // Close PopUp
    this.actions.close();
  }

  private async beforeRequest() {
    const beforeUpdateAcion = this.currentMode.beforeUpdatePassword;
    if (beforeUpdateAcion) {
      const isValid = await beforeUpdateAcion(this.tkForm.row);
      if (!isValid) {
        return false;
      }
    }

    this.tkForm.loading = true;
    this.actions.saveDisabled = true;
    return true;
  }

  private afterRequest() {
    this.tkForm.loading = false;
    this.actions.saveDisabled = false;
  }
  // [ METHODS ]
}